import type from "./type";

export default type("text/plain", function(xhr) {
  return xhr.responseText;
});



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-request/src/text.js
// module id = ../../../../d3-request/src/text.js
// module chunks = 3